export const NAME: string = "SearchAdder";